import { Image as TiptapImage } from '@tiptap/extension-image'
import { VueNodeViewRenderer } from '@tiptap/vue-3'

import { IMAGE_SIZE } from '@/tiptap/constants/define'
import { ImageActionButton } from './components/ActionButton'

import ImageDialog from './components/image/ImageDialog.vue'
import ImageView from './components/image/ImageView.vue'
import { tiptapUploadImage } from '@/utils/tiptapImageUploader'

// JS port of the TS version. Types/interfaces and module augmentation are omitted on purpose.
// The `upload` option should be a function: (file: File) => Promise<string>

export const Image = /* @__PURE__ */ TiptapImage.extend({
  addAttributes() {
    const parent = typeof this.parent === 'function' ? this.parent() : {}
    return {
      ...parent,
      src: {
        default: null,
      },
      alt: {
        default: null,
      },
      lockAspectRatio: {
        default: true,
      },
      width: {
        default: this.options.width,
      },
      height: {
        default: null,
      },
      display: {
        default: this.options.display,
        renderHTML: ({ display }) => {
          if (!display) return {}
          return { 'data-display': display }
        },
        parseHTML: (element) => {
          const display = element.getAttribute('data-display')
          return display || 'inline'
        },
      },
    }
  },

  addNodeView() {
    return VueNodeViewRenderer(ImageView)
  },

  addCommands() {
    const parent = typeof this.parent === 'function' ? this.parent() : {}
    return {
      ...parent,
      updateImage:
        (options = {}) =>
        ({ commands }) => {
          return commands.updateAttributes(this.name, options)
        },
    }
  },

  addOptions() {
    const parent = typeof this.parent === 'function' ? this.parent() : {}
    return {
      ...parent,
      upload: tiptapUploadImage,
      width: IMAGE_SIZE['size-small'],
      display: 'inline',
      imageTabs: ['upload', 'url'],
      hiddenTabs: [],
      inline: true,
      dialogComponent: () => ImageDialog,
      button: ({ editor, extension, t }) => {
        const { upload, imageTabs, hiddenTabs, dialogComponent } = extension.options || {}

        return {
          component: ImageActionButton,
          componentProps: {
            editor,
            t,
            upload,
            imageTabs,
            hiddenTabs,
          },
          componentSlots: {
            dialog: dialogComponent(),
          },
        }
      },
    }
  },
})